<template>
  <header class="app-header">
    <router-link to="/" class="brand-name">
      {{ content.name }}
    </router-link>

    <nav class="nav-icons">
      <a href="/" class="icon-btn" aria-label="Home">
        <Home :size="20" stroke-width="1.5" />
      </a>
      <a :href="content.links.github" target="_blank" class="icon-btn" aria-label="GitHub">
        <Github :size="20" stroke-width="1.5" />
      </a>
      <a :href="content.links.instagram" target="_blank" class="icon-btn" aria-label="Instagram">
        <Instagram :size="20" stroke-width="1.5" />
      </a>
      <a :href="`mailto:${content.links.email}`" class="icon-btn" aria-label="Email">
        <Mail :size="20" stroke-width="1.5" />
      </a>
      <a :href="content.links.linkedin" target="_blank" class="icon-btn" aria-label="LinkedIn">
        <Linkedin :size="20" stroke-width="1.5" />
      </a>
      <button @click="toggleTheme" class="icon-btn" aria-label="Toggle Theme">
        <Sun v-if="isDark" :size="18" />
        <Moon v-else :size="18" />
      </button>
    </nav>
  </header>
</template>

<script setup lang="ts">
import { Github, Linkedin, Instagram, Mail, Sun, Home, Moon } from 'lucide-vue-next';
import { content } from "@/content/data"
import { useTheme } from '@/composables/useTheme'

const { isDark, toggleTheme } = useTheme()
</script>

<style scoped>
.app-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 0;
  margin-bottom: 2rem;
}

.nav-icons {
  display: flex;
  gap: 1.25rem;
  align-items: center;
}
</style>
